export default "__VITE_ASSET__58b7c335__"